var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscounts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    viewBox: "0 0 60 60",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#314e55",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(6 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v18h-48z",
    fill: "#ea86a5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 5h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 9h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 13h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 13h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 13h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 5h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 9h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 5v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 9v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 13v-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 13v-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 13v-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 13v-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 5h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 9h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 18v4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1 23h46v23h-46z",
    fill: "#d8d8d8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 28h18v18h-18z",
    fill: "#c59981",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 36h2v2h-2z",
    fill: "#d8d8d8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 28h6v9h-6z",
    fill: "#73c9c9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 28h6v9h-6z",
    fill: "#73c9c9",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscounts);
export default __webpack_public_path__ + "static/media/discounts.fcfc21907aa6c85284f1900dd6854cf6.svg";
export { ForwardRef as ReactComponent };